import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import type * as React from 'react';
import type {FallbackProps} from 'react-error-boundary';
import PaddedContainer from '../components/PaddedContainer';

const ErrorFallback: React.FC<FallbackProps> = ({resetErrorBoundary}: FallbackProps) => {
    return (
        <PaddedContainer>
            <Card>
                <CardHeader title='Whoops, an error occurred' />
                <CardContent>
                    <Typography>An unexpected error occurred. Please reload the app.</Typography>
                </CardContent>
                <CardActions>
                    <Button size='small' onClick={resetErrorBoundary}>
                        Reload
                    </Button>
                </CardActions>
            </Card>
        </PaddedContainer>
    );
};

export default ErrorFallback;
